import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EmployeeCategory.scss';

const ChartTooltips = ({ active, payload }) => {
  const { t } = useTranslation();
  if (active && payload && payload.length) {
    return (
      <div className={styles.tooltip}>
        <div className={styles.content}>
          <div className={styles.title} style={{ color: payload[0].payload.color }}>
            {payload[0].name ? payload[0].name : t('features.Dashbord.components.EmployeeCategory.not_assigned')}
          </div>
          <div>{payload[0].value}</div>
          <div className={styles.text}>{t('features.Dashbord.components.EmployeeCategory.click_to_go_to_employee_list_page')} </div>
        </div>
      </div>
    );
  }
  return null;
};

export default ChartTooltips;
